import {
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { TRUCK_TYPE_IMPORT_JOB_STATUS_TYPE } from '@/libs/api/types'

/**
 * 車両属性のインポート履歴の検索条件
 */
export const truckTypeImportJobsSearchSchema = object({
  dcId: optional(number()),
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(TRUCK_TYPE_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string())
})

export type TruckTypeImportJobsSearch = InferOutput<
  typeof truckTypeImportJobsSearchSchema
>
